import React, { useState } from "react"
import { injectIntl } from "react-intl"
import { withRouter } from "react-router-dom"
import ReactTooltip, { Place } from "react-tooltip"
import Icon from "../../icon/icon.component"
import FeatureProtectionWrapperMain from "./featureProtectionWrapperMain.component"
import { messages, getMessage, handleClick } from "./helpers.jsx"
import { Intl } from "../../../state/helpers/IntlProps"

type OwnProps = {
    isProtected: boolean
    protectionRule: boolean
    disabled: boolean
    protectedClassName: string
    accountFeatureKey: string
    className: string
    type: "button" | "submit" | "reset"
    tooltipPosition: Place
    children: JSX.Element
    showLock: boolean
    premium: boolean
    message: string
    callback: () => void
    onClose: () => void
    onClickProtected: () => void
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    intl: Intl
}

const ButtonWrapper = (props: OwnProps) => {
    const [displayModal, setDisplayModal] = useState(false)
    const showLock = props.showLock ?? true

    const lockedItem = <span key={"tooltip-container"} data-tip data-for={"buttonLock"}>
        <button key={"button-wrapper"} className={props.protectedClassName || "btn"} onClick={(e) => {
            handleClick(e, props, setDisplayModal)
        }} disabled={props.disabled} type={props.type}>
            <ReactTooltip place={props.tooltipPosition}
                className="buttonLock"
                id={"buttonLock"}
                type="warning"
                effect="solid"
                multiline={true}
            >
                {getMessage(props.message, props.intl.formatMessage(messages["update_subscription"]))}
            </ReactTooltip>
            {props.children} {showLock && <Icon value="lock" className="lock"/>}
        </button>
    </span>


    const item = <button key={"button-wrapper"} className={props.className} onClick={(e) => {
        props.onClick(e)
    }} disabled={props.disabled} type={props.type}>
        {props.children}
    </button>

    return (<>
        <FeatureProtectionWrapperMain
            protectionRule={props.protectionRule}
            accountFeatureKey={props.accountFeatureKey}
            isProtected={props.isProtected ?? true}
            displayModal={displayModal}
            premium={props.premium}
            lockedItem={lockedItem}
            message={props.message}
            item={item}
            callback={props.callback || function () {
                return
            }}
            onClickProtected={props.onClickProtected || function () {
                return
            }}
            onClose={() => {
                setDisplayModal(false)
                if (props.onClose) {
                    props.onClose()
                }
            }}
            onClick={props.onClick || function () {
                return
            }}
        >

        </FeatureProtectionWrapperMain>
    </>)


}

export default withRouter(injectIntl(ButtonWrapper))


// WEBPACK FOOTER //
// ./src/common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component.tsx